import { nb } from '@/i18n/nb';
import gjestebokPhoto from '@/assets/gjestebok.jpg';
import s from './Gjestebok.module.css';

/*
 * Public Gjestebok view, rendered inside the landing slide-overlay (mirrors OmHytta).
 * Read-only placeholder: a photograph of the physical guestbook + a short Norwegian
 * paragraph pointing guests to the real book. No digital sign-in at MVP (Iter 9).
 */
export function Gjestebok() {
  return (
    <figure className={s.gjestebok}>
      <img className={s.photo} src={gjestebokPhoto} alt={nb.gjestebok.photoAlt} />
      <figcaption className={s.body}>{nb.gjestebok.body}</figcaption>
    </figure>
  );
}
